var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0C35.8172 0 0 35.8172 0 80C0 124.183 35.8172 160 80 160Z",
    fill: "#141E30",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3757 33.1686V48.2483H41.2681V126.83H112.59V33.1686H56.3757Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3757 33.1686L41.2681 48.2483H56.3757V33.1686Z",
    fill: "#141E30",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.489 91.7836H52.2005C51.0669 91.7836 50.1479 92.7025 50.1479 93.8361C50.1479 94.9697 51.0669 95.8886 52.2005 95.8886H101.489C102.622 95.8886 103.541 94.9697 103.541 93.8361C103.541 92.7025 102.622 91.7836 101.489 91.7836Z",
    fill: "#141E30",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.489 100.412H52.2005C51.0669 100.412 50.1479 101.331 50.1479 102.464C50.1479 103.598 51.0669 104.517 52.2005 104.517H101.489C102.622 104.517 103.541 103.598 103.541 102.464C103.541 101.331 102.622 100.412 101.489 100.412Z",
    fill: "#141E30",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7349 109.069H52.2005C51.0669 109.069 50.1479 109.987 50.1479 111.121C50.1479 112.255 51.0669 113.174 52.2005 113.174H79.7349C80.8685 113.174 81.7874 112.255 81.7874 111.121C81.7874 109.987 80.8685 109.069 79.7349 109.069Z",
    fill: "#141E30",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7436 87.6686L103.502 82.9098L93.7874 73.1947L89.0286 77.9535L98.7436 87.6686Z",
    fill: "#141E30"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1666 85.6683C91.965 85.6683 101.53 76.1038 101.53 64.3054C101.53 52.5069 91.965 42.9424 80.1666 42.9424C68.3682 42.9424 58.8037 52.5069 58.8037 64.3054C58.8037 76.1038 68.3682 85.6683 80.1666 85.6683Z",
    fill: "#141E30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1631 80.8088C89.2779 80.8088 96.667 73.4197 96.667 64.3049C96.667 55.19 89.2779 47.801 80.1631 47.801C71.0482 47.801 63.6592 55.19 63.6592 64.3049C63.6592 73.4197 71.0482 80.8088 80.1631 80.8088Z",
    fill: "#F2F6F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.259 80.1385L95.9981 87.3991C95.7467 87.6504 95.7467 88.0972 95.9981 88.3486L115.602 107.952C115.853 108.204 116.3 108.204 116.551 107.952L123.812 100.692C124.063 100.44 124.063 99.9934 123.812 99.7421L104.208 80.1385C103.957 79.8872 103.538 79.8872 103.259 80.1385Z",
    fill: "#65AFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0647 91.4358L112.571 104.942L120.785 96.7275L107.279 83.2214L99.0647 91.4358Z",
    fill: "#5E7CE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.e13c13ec.svg";
export { ForwardRef as ReactComponent };